module.exports = __webpack_public_path__ + "static/media/1.af32846c.JPG";